import BulkDeleteConfirmationContainer from "./BulkDeleteConfirmationContainer";
export default BulkDeleteConfirmationContainer;
